import { useFindMentorship } from "@/lib/api/mentorships";
import { useSafeChannelContext } from "@/lib/sendbird/use-safe-channel-context";
import { useSendbirdStateContext } from "@sendbird/uikit-react";

export function useGetChannelMentorship() {
  const store = useSendbirdStateContext();
  const channelStore = useSafeChannelContext();
  const channel = channelStore?.currentGroupChannel;

  const membersExcludingMentor = channel?.members?.filter(
    (member) => member.userId !== store.config.userId,
  );

  const menteeId = membersExcludingMentor?.[0]?.userId || "";
  const mentorId = store.config.userId || "";

  const { data: mentorship, isLoading } = useFindMentorship(
    mentorId,
    menteeId,
  );

  return {
    mentorship,
    isLoading,
  };
}
